import React from 'react';

import Modal from '../../../../../../components/Modal/Modal';
import CheckBox from '../../../../../../components/input/CheckBox';
import TextAreaForm from '../../../../../../components/form/TextAreaForm';
import CountOfTotal from '../../../../../../components/CountOfTotal';
import {
  COUPON_AVAILABLE_TYPE_TEXT,
  MAXIMUM_NUMBER_OF_COUPON_MEMO_TEXT,
} from '../../../../../../constants/service/app/couponConstants';
import InfoTable from '../../../../../../components/table/InfoTable';
import { setDash, setPhoneFormat } from '../../../../../../lib/common';
import {
  setCouponGenerateLimitCount,
  setCouponPeriod,
  setDiscountBenefit,
  setDiscountType,
} from '../../../../../../lib/utils/couponUtils';

const GenerateCouponValidSuccessModalView = (props) => {
  const {
    isOpen = true,
    validResult,
    form,
    isSendAlimtalk,
    setIsSendAlimtalk,
    memo,
    setMemo,
    closeModal,
    onGenerateCoupon,
  } = props;
  const { requestCnt, possibleCnt, impossibleCnt, userCouponList } = validResult;

  return (
    <Modal
      title="쿠폰 발급"
      isOpen={isOpen}
      width={1550}
      height={600}
      isFooter={true}
      okText="발급하기"
      onOk={onGenerateCoupon}
      onClose={() => closeModal()}
    >
      <div className="generate-coupon-valid-success-modal-wrap">
        <div className="generate-coupon-valid-success-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>
            모든 요청이 쿠폰 발급이 가능합니다.
            <CheckBox
              className="is-send-alimtalk"
              text="알림톡 발송 여부"
              checked={isSendAlimtalk}
              onChange={(checked) => setIsSendAlimtalk(checked)}
            />
          </div>

          <div className="coupon-generate-selected-user-list-memo">
            {/*메모*/}
            <TextAreaForm
              form={form}
              label={
                <span>
                  <span>메모</span>
                  <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_COUPON_MEMO_TEXT} />
                </span>
              }
              initialValue={memo}
              maxLength={MAXIMUM_NUMBER_OF_COUPON_MEMO_TEXT}
              onChange={(value) => setMemo(value)}
              name="memo"
              rows={4}
            />
          </div>
        </div>

        <div className="generate-coupon-valid-success-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>회원 번호</th>
                <th>이름</th>
                <th>회원 ID</th>
                <th>휴대전화 번호</th>
                <th>쿠폰 번호</th>
                <th>쿠폰 발급 수량</th>
                <th>쿠폰명</th>
                <th>쿠폰 설명</th>
                <th>쿠폰 혜택</th>
                <th>쿠폰 유형</th>
                <th>쿠폰 혜택 정보</th>
                <th>쿠폰 발급 제한 횟수</th>
                <th>사용 기간</th>
              </tr>
            </thead>
            <tbody>
              {userCouponList.map((item) => (
                <tr key={item.id}>
                  <td className="tc">{item.userId}</td>
                  <td className="tc">{setDash(item.userName)}</td>
                  <td className="tc">{item.account}</td>
                  <td className="tc">{setDash(setPhoneFormat(item.cellPhone))}</td>
                  <td className="tc">{item.couponId}</td>
                  <td className="tc">{item.issuedCount}</td>
                  <td className="tc">{item.couponName}</td>
                  <td className="tc">{setDash(item.description)}</td>
                  <td className="tc">{setDiscountType(item.discountType, item.discountAmount)}</td>
                  <td className="tc">{COUPON_AVAILABLE_TYPE_TEXT[item.availableType]}</td>
                  <td className="tc">
                    {setDiscountBenefit(
                      item.discountType,
                      item.discountAmount,
                      item.minimumPurchasePrice,
                      item.maxDiscountPrice,
                    )}
                  </td>
                  <td className="tc">{setCouponGenerateLimitCount(item.generateLimitDay, item.generateLimitCount)}</td>
                  <td className="tc">
                    {setCouponPeriod(
                      item.periodType,
                      { startDate: item.startDate, endDate: item.endDate },
                      item.dayPlus,
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default GenerateCouponValidSuccessModalView;
